import { AlertTriangle, Clock, FileText, Truck, ArrowRight, CheckCircle2 } from "lucide-react";

// Auto-flags things silently slipping. ADHD: counters out-of-sight-out-of-mind.
export const NeedsAttention = ({ data, onNavigate }) => {
  if (!data || data.total === 0) {
    return (
      <div className="border p-5 flex items-center gap-3" style={{ backgroundColor: "var(--dash-card)", borderColor: "var(--dash-border)" }} data-testid="needs-attention-clear">
        <CheckCircle2 size={20} className="text-[#22c55e]" />
        <span className="font-body text-sm" style={{ color: "var(--dash-text-muted)" }}>Nothing slipping — you're on top of it.</span>
      </div>
    );
  }

  const rows = [];
  (data.unactioned_quotes || []).forEach((q) =>
    rows.push({
      key: `q-${q.id}`, icon: FileText, accent: "#f59e0b",
      title: `${q.name} — ${q.vehicle_model || "quote"}`,
      note: `Quote waiting ${q.days_waiting} day${q.days_waiting === 1 ? "" : "s"}`,
      go: () => onNavigate("quotes", "leads"),
    })
  );
  (data.ready_pickup || []).forEach((j) =>
    rows.push({
      key: `r-${j.id}`, icon: Truck, accent: "#22c55e",
      title: `${j.vehicle} — ${j.customer_name}`,
      note: "Ready for pickup — chase the customer",
      go: () => onNavigate("jobs", "work"),
    })
  );
  (data.stalled_jobs || []).forEach((j) =>
    rows.push({
      key: `s-${j.id}`, icon: Clock, accent: "#ef4444",
      title: `${j.vehicle} — ${j.customer_name}`,
      note: `No progress in ${j.days_idle} days`,
      go: () => onNavigate("jobs", "work"),
    })
  );

  return (
    <div data-testid="needs-attention">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle size={16} className="text-[#f59e0b]" />
        <h3 className="font-body text-xs tracking-[0.2em] uppercase" style={{ color: "var(--dash-text-muted)" }}>
          Needs attention ({data.total})
        </h3>
      </div>
      <div className="space-y-2">
        {rows.map((r) => {
          const Icon = r.icon;
          return (
            <button
              key={r.key}
              onClick={r.go}
              data-testid={`attention-row-${r.key}`}
              className="w-full flex items-center gap-3 p-4 text-left border cursor-pointer transition-colors hover:brightness-110"
              style={{ backgroundColor: "var(--dash-card)", borderColor: "var(--dash-border)", borderLeft: `3px solid ${r.accent}` }}
            >
              <Icon size={18} style={{ color: r.accent }} className="flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="font-body text-sm truncate" style={{ color: "var(--dash-text)" }}>{r.title}</p>
                <p className="font-body text-xs truncate" style={{ color: r.accent }}>{r.note}</p>
              </div>
              <ArrowRight size={16} style={{ color: "var(--dash-text-dim)" }} className="flex-shrink-0" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default NeedsAttention;
